export class TimeSpan {
  static fromTo(from: Date, to: Date, ignoreSeconds: boolean): TimeSpan {
    return ignoreSeconds
      ? new TimeSpan(this.toZeroSecond(from), this.toZeroSecond(to))
      : new TimeSpan(from, to);
  }

  static toZeroSecond(source: Date): Date {
    return !source
      ? null
      : new Date(
        source.getFullYear(),
        source.getMonth(),
        source.getDate(),
        source.getHours(),
        source.getMinutes(),
        0,
        0
      );
  }

  static areEqual(a: TimeSpan, b: TimeSpan) {
    return (a === b)
        || ((a && b)
         && (a.from.getTime() === b.from.getTime())
         && (a.to.getTime() === b.to.getTime()));
  }

  constructor(a: Date, b: Date) {
    this._from = this.createNewDate((a < b) ? a : b);
    this._to = this.createNewDate((a < b) ? b : a);
  }

  private createNewDate(source: Date): Date {
    const result = new Date();
    result.setTime(source.getTime());
    return result;
  }

  private _from: Date;
  private _to: Date;

  get from(): Date {
    return this.createNewDate(this._from);
  }

  set from(value: Date) {
    this._from = this.createNewDate(value);
  }

  get to(): Date {
    return this.createNewDate(this._to);
  }

  set to(value: Date) {
    this._to = this.createNewDate(value);
  }

  get days(): number {
    return Math.floor(this.times / (1000 * 60 * 60 * 24));
  }

  get hours(): number {
    return Math.floor((this.times % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  }

  get minutes(): number {
    return Math.floor((this.times % (1000 * 60 * 60)) / (1000 * 60));
  }

  get seconds(): number {
    return Math.floor((this.times % (1000 * 60)) / 1000);
  }

  get milliseconds(): number {
    return this.times % 1000;
  }

  get times(): number {
    return this.to.getTime() - this.from.getTime();
  }

  toDateString(): string {
    return ((0 < this.days) ? this.days + "日" : "")
      + ((0 < this.hours) ? this.hours + "時間" : "")
      + (((this.times < (1000 * 60 * 60)) || (0 < this.minutes)) ? this.minutes + "分" : "0分");
  }

  toHourString(): string {
    return (this.days * 24 + this.hours) + "時間" + this.minutes + "分";
  }

  toMinuteString(): string {
    return (this.days * 60 * 24 + this.hours * 60 + this.minutes) + "分";
  }

  public static toMinutesFromText(text: string): number {
    if (!text) { return null; }
    const dayIndex = text.indexOf("日");
    const hourIndex = text.indexOf("時間");
    const minuteIndex = text.indexOf("分");
    console.warn(text);
    const days = this.extractNumber(text, 0, dayIndex);
    const hours = this.extractNumber(text, (dayIndex < 0 ? -1 : dayIndex + 1), hourIndex);
    // 1日0分など、時間がないときがある
    const minuteStartIndex = (hourIndex < 0)
      ? (dayIndex < 0 ? -1 : dayIndex + 1)
      : hourIndex + 2;
    const minutes = this.extractNumber(text, minuteStartIndex, minuteIndex);
    return (days * 60 * 24) + (hours * 60) + minutes;
  }

  private static extractNumber(text: string, start: number, end: number): number {
    if (end < 0) { return 0; }
    const sliced = (start < 0) ? text.slice(0, end) : text.slice(start, end);
    if (!sliced || sliced === "") { return 0; }
    return Number(sliced);
  }

  clone(): TimeSpan {
    return new TimeSpan(
      this.from,
      this.to
    );
  }
}
